/**
 * @fileoverview NavigationMenu component provides dropdown navigation menu.
 * Displays navigation options grouped by category (Budgets, Budget Management, Settings).
 */

import MenuButton from './MenuButton';
import styles from './NavigationMenu.module.css';

/**
 * NavigationMenu Component
 *
 * Dropdown menu with navigation options
 */
function NavigationMenu({ menuOpen, currentPage, handleMenuClick, userRole, setMenuOpen, isAdmin }) {
    if (!menuOpen) return null;

    return (
        <>
            {/* Overlay to close menu when clicking outside */}
            <div
                onClick={() => setMenuOpen(false)}
                className={styles.overlay}
            />

            {/* Menu */}
            <div className={styles.menu}>
                {/* Budget Tracker - no header */}
                <MenuButton
                    onClick={() => handleMenuClick('budget-tracker')}
                    isActive={currentPage === 'budget-tracker'}
                >
                    Budget Tracker
                </MenuButton>

                {/* Maintenance Section Header */}
                <div className={styles.sectionHeader}>
                    Maintenance
                </div>

                <MenuButton
                    onClick={() => handleMenuClick('budget-allocation')}
                    isActive={currentPage === 'budget-allocation'}
                >
                    Budget Allocation
                </MenuButton>

                <MenuButton
                    onClick={() => handleMenuClick('budget-template')}
                    isActive={currentPage === 'budget-template'}
                >
                    Budget Template
                </MenuButton>

                {/* Categories - hide for members */}
                {userRole !== 'member' && (
                    <MenuButton
                        onClick={() => handleMenuClick('categories')}
                        isActive={currentPage === 'categories'}
                    >
                        Categories
                    </MenuButton>
                )}

                {/* Settings Section Header */}
                <div className={styles.sectionHeader}>
                    Settings
                </div>

                <MenuButton
                    onClick={() => handleMenuClick('profile')}
                    isActive={currentPage === 'profile'}
                >
                    Profile
                </MenuButton>

                <MenuButton
                    onClick={() => handleMenuClick('create-budget')}
                    isActive={currentPage === 'create-budget'}
                >
                    Create New Budget
                </MenuButton>

                <MenuButton
                    onClick={() => handleMenuClick('invites')}
                    isActive={currentPage === 'invites'}
                >
                    Invites
                </MenuButton>

                {/* Reports & Search Section Header */}
                <div className={styles.sectionHeader}>
                    Reports & Search
                </div>

                <MenuButton
                    onClick={() => handleMenuClick('report-transaction-type')}
                    isActive={currentPage === 'report-transaction-type'}
                >
                    Transaction Type Search
                </MenuButton>

                <MenuButton
                    onClick={() => handleMenuClick('report-category')}
                    isActive={currentPage === 'report-category'}
                >
                    Category Search
                </MenuButton>

                <MenuButton
                    onClick={() => handleMenuClick('report-month-comparison')}
                    isActive={currentPage === 'report-month-comparison'}
                >
                    Month-to-Month Comparison
                </MenuButton>

                {/* Admin Section - only visible to admins */}
                {isAdmin && (
                    <>
                        <div className={styles.sectionHeader}>
                            Admin
                        </div>
                        <MenuButton
                            onClick={() => handleMenuClick('admin-users')}
                            isActive={currentPage === 'admin-users'}
                        >
                            User Approval
                        </MenuButton>
                    </>
                )}
            </div>
        </>
    );
}

export default NavigationMenu;
